var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 41,
    viewBox: "0 0 34 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0374 13.7247C31.8039 13.9062 27.7081 16.2134 27.7081 21.3462C27.7081 27.2827 32.9187 29.3826 33.0743 29.4343C33.0484 29.5638 32.2447 32.3118 30.3263 35.1115C28.6154 37.5743 26.8265 40.0369 24.1046 40.0369C21.3828 40.0369 20.6827 38.4556 17.5459 38.4556C14.4869 38.4556 13.3981 40.0889 10.9094 40.0889C8.42066 40.0889 6.68372 37.8075 4.68773 35.0078C2.3805 31.7154 0.514038 26.6085 0.514038 21.7608C0.514038 13.9837 5.56926 9.86174 10.5464 9.86174C13.1907 9.86174 15.3941 11.5987 17.0532 11.5987C18.6345 11.5987 21.0974 9.75808 24.1044 9.75808C25.2452 9.75833 29.3413 9.86224 32.0374 13.7247V13.7247ZM22.6789 6.46616C23.9232 4.9885 24.8047 2.94055 24.8047 0.892612C24.8047 0.607472 24.7788 0.322331 24.7269 0.0888977C22.7048 0.166709 20.2939 1.43704 18.8421 3.12203C17.7015 4.41822 16.6385 6.46616 16.6385 8.5402C16.6385 8.8512 16.6905 9.16244 16.7163 9.26611C16.8459 9.29196 17.0534 9.31807 17.2608 9.31807C19.0755 9.31782 21.3567 8.09944 22.6789 6.46616V6.46616Z",
    fill: "black",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.e23b7516cd0f7772585493a3c5d73bce.svg";
export { ForwardRef as ReactComponent };